export const DefaultData = {
  filters: {
    startDate: '',
    endDate: '',
    period: '',
    categories: [],
    categoriesData: [],
    cumulative: true,
    countries: [],
    areas: [],
    groups: [],
    dealers: [],
    customerTypes: [],
    invoiceTypes: [1],
    paymentTypes: [],
    vehicleAge: [],
    vehicleAgeType: false,
    vehicleAgeAll: false,
    vehicleBrands: [],
    vehicleSegments: [],
    vehicleModels: [],
    workshopTypes: [],
    queryFilters: '',
    changeCat: false,
    trend: false
  },
  slider: 2
};

export const DataReducer = (data, { type, payload }) => {
  switch (type) {
    case 'SET_FILTERS':
      return {
        ...data,
        filters: {
          ...payload,
        }
      };
    case 'SET_CATEGORIES_DATA':
      return {
        ...data,
        filters: {
          ...data.filters,
          categoriesData: payload,
        }
      };
    case 'SET_SLIDER':
      return {
        ...data,
        slider: payload,
      };
  default:
    return data;
  }
};
